// removed by extract-text-webpack-plugin
module.exports = {"container":"src-display-modules-Home-Workbench-UI-AppError__container--27LE5","body":"src-display-modules-Home-Workbench-UI-AppError__body--2gDE9"};


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/Workbench/UI.AppError.scss
// module id = 6931
// module chunks = 0